/**
 * PickType display names (Jacob, 2026-10-07; Wing -> Side 2026-10-20). Labels only: the definitions
 * are unchanged, and core's stored values move to the new names separately,
 * so a report or action-detail payload may carry either vocabulary. Every
 * surface that shows a PickType value goes through `pickTypeLabel`; filter
 * values and drill-down contexts keep the stored value.
 */
export const PICK_TYPE_LABELS: Record<string, string> = {
  Elbow: "Middle",
  Shake: "Angle Flip",
  "Step Empty": "Step",
  Wing: "Side",
};

/** Old name → new name; a new (or unknown) name passes through. */
export function pickTypeLabel(value: string): string {
  return PICK_TYPE_LABELS[value] ?? value;
}

/**
 * One-line definitions under each type's hover diagram (PickTypeDiagram), keyed by display name. Written as a coach
 * would say it (Trevor, 2026-10-20); the geometry behind each is update/core/rules.py pick_type / pick_type_v3. Middle
 * Other has none: v3 folds it into Middle and Flat.
 */
export const PICK_TYPE_DEFINITIONS: Record<string, string> = {
  Middle: "Middle screen, with 5-out spacing.",
  Flat: "Middle screen, with flat spacing: both corners and the dunker spot filled.",
  Corner: "Pick and roll in the corner, with the handler turning back to the middle.",
  "Angle Flip": "Side pick and roll with the strongside corner filled.",
  Side: "Side pick and roll with the strongside corner empty.",
  Angle: "Step-up screen sending the handler baseline, with the strongside corner filled.",
  Step:
    "Step-up screen sending the handler baseline, with the strongside corner empty. The dunker can stay or lift to " +
    "the perimeter.",
  "3-Man": "Two screeners in one action: horns, 77, Spain or screen-the-screener.",
  "Quick Ghost": "Ghost screen: the screener slips out before setting it and pops instead of rolling.",
};
